import React from 'react';

interface PlaylistIconProps {
  size?: number;
  color?: string;
  className?: string;
  filled?: boolean;
}

export const PlaylistIcon: React.FC<PlaylistIconProps> = ({
  size = 16,
  color,
  className,
  filled = false,
}) => {
  const resolvedColor =
    color ?? (filled ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.4)');

  return filled ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M6.68945 0C10.3837 0.000142763 13.3779 2.9952 13.3779 6.68945C13.3778 10.3836 10.3836 13.3778 6.68945 13.3779C2.9952 13.3779 0.000142766 10.3837 0 6.68945C0 2.99512 2.99512 0 6.68945 0ZM4.8623 2.5752C4.59572 2.39638 4.2373 2.58808 4.2373 2.90918V9.83105C4.23762 10.1519 4.59583 10.3429 4.8623 10.1641L10.0127 6.70312C10.2494 6.54409 10.2494 6.19517 10.0127 6.03613L4.8623 2.5752Z"
        fill={resolvedColor}
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M8.47709 5.20787C8.67168 5.33863 8.67168 5.62491 8.47709 5.75567L4.2425 8.60131C4.02327 8.74862 3.72843 8.59153 3.72843 8.32741L3.72843 2.63613C3.72843 2.37201 4.02328 2.21491 4.2425 2.36223L8.47709 5.20787Z"
        fill={resolvedColor}
      />
      <path
        d="M10 5.5C10 3.01472 7.98528 1 5.5 1C3.01472 1 1 3.01472 1 5.5C1 7.98528 3.01472 10 5.5 10L5.5 11C2.46243 11 6.55848e-09 8.53757 1.46489e-08 5.5C2.27394e-08 2.46243 2.46243 6.55861e-09 5.5 1.46491e-08C8.53757 2.27395e-08 11 2.46243 11 5.5C11 8.53757 8.53757 11 5.5 11L5.5 10C7.98528 10 10 7.98528 10 5.5Z"
        fill={resolvedColor}
      />
    </svg>
  );
};

export default PlaylistIcon;
